import MachineSessionModalReducer from "@common/redux/reducers/MachineSessionModalReducer";
import BaseAction from "@common/redux/actions/BaseAction";

class MachineSessionModalAction extends BaseAction {
  onClose = async (linked) => {};

  open = async (onClose) => {
    this.dispatch({ open: true });
    this.onClose = onClose;
  };
}

const action = new MachineSessionModalAction(MachineSessionModalReducer);

export default action;
